var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.31 21.29c.12-.62 3.78-3.38 6.94-5.83l-1.18-.38a.85.85 0 0 1-.56-1l1.16-4.18-3.18.87a1 1 0 0 1-1.26-.84l-.15-1.27-3.27 3.15a.38.38 0 0 1-.64-.35l1.31-7-1.84 1a.59.59 0 0 1-.81-.25L13.14 0l-2.68 5.21a.6.6 0 0 1-.82.25l-1.84-1 1.31 7a.38.38 0 0 1-.64.35L5.21 8.66 5.06 9.9a1 1 0 0 1-1.27.84L.58 9.87l1.16 4.18a.85.85 0 0 1-.56 1L0 15.43c3.16 2.45 6.82 5.21 6.94 5.83s-1 2.35-1 2.35a38.53 38.53 0 0 1 5.38-1.41c.94 0 1.17.85 1.17 1.7s-.55 6.45-.27 6.65a2.65 2.65 0 0 0 1.78 0c.22-.2-.27-5.8-.27-6.65s.23-1.68 1.17-1.7c1.825.34 3.623.811 5.38 1.41 0 0-1.11-1.59-.97-2.32z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutumn);
export default __webpack_public_path__ + "static/media/autumn.0a67bce2af2d322a547890ac929e24e0.svg";
export { ForwardRef as ReactComponent };